<template>
  <div
    v-observe-visibility="observeVisiblity()"
    :class="`product-item ${stockManagedClass}`"
  >
    <template v-if="isVisible">
      <CarouselProductHoverCard
        v-if="hoverCardEnabled"
        :item="item"
      />
      <CarouselProductImage :item="item" />
      <CarouselProductContent :item="item" />
    </template>
  </div>
</template>

<script>
// Components
import CarouselProductHoverCard from '../../components/grid/CarouselProductHoverCard'
import CarouselProductImage from '../../components/grid/carouselProductImage.vue'
import CarouselProductContent from '../../components/grid/carouselProductContent.vue'

// Mixins
import carouselProductMixin from '../../mixins/carouselProductMixin'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'

export default {
  name: 'product-grid-item',
  components: {CarouselProductHoverCard, CarouselProductImage, CarouselProductContent},
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss">
@import "../../styles/product-grid-card-styles.scss";
</style>
